import { useEffect } from "react";
import { useThrottledCallback } from "use-debounce";
import { tokenExpiredEventName } from "../../api/helpers/helpers";
import { getAccountId } from "../../common/helpres/link";
import { usePrevious } from "../../common/hooks/usePrevious";
import { isMainAppDevOrCi } from "../consts/links";
import { useAccountsStore } from "../store/accountsStore";
import { clearToken, useCheckLoginController, useCredentialsStore, useTokenController, } from "../store/credentialsStore";
export const useCredentials = (accountId) => {
    const token = useCredentialsStore((state) => state.main?.token);
    const clearTokenDebounced = useThrottledCallback(clearToken, 5000, {
        leading: true,
        trailing: false,
    });
    const prevAccountId = usePrevious(accountId);
    useEffect(() => {
        if (!token || (prevAccountId != null && prevAccountId !== accountId)) {
            useTokenController.action(accountId);
        }
    }, [token, accountId]);
    useEffect(() => {
        if (!isMainAppDevOrCi) {
            window.addEventListener(tokenExpiredEventName, clearTokenDebounced, false);
            return () => {
                window.removeEventListener(tokenExpiredEventName, clearTokenDebounced);
            };
        }
    }, []);
    return token;
};
export const useAccountPlans = ({ accountId }) => {
    useEffect(() => {
        if (accountId) {
            useCheckLoginController.action();
        }
    }, [accountId]);
};
export const useToolAvailableForSubAccount = (tools) => {
    const data = useAccountsStore((s) => s.accounts[Number(getAccountId())]);
    if (!data) {
        return null;
    }
    else if (data.role === 2) {
        return tools.reduce((acc, tool) => {
            return data.permissions.includes(tool) && acc;
        }, true);
    }
    else {
        return true;
    }
};
